import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading…
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center flex-col gap-3 p-8">
        <div className="text-lg heading">Access denied</div>
        <div className="text-sm text-slate-500">Your role ({user.role}) does not have access to this page.</div>
      </div>
    );
  }
  return children;
}
